/**
 * Helpers for the GGA fix-quality field reported by rovers.
 *
 * Source of truth: NMEA 0183 GGA field 6.
 * Color palette mirrors typical RTK survey conventions:
 *   1 = Single        → red       (no correction applied)
 *   2 = DGPS          → orange    (sub-metre)
 *   5 = Float RTK     → yellow    (cm-level but not converged)
 *   4 = Fix RTK       → green     (cm-level converged)
 *   anything else     → grey
 */

export interface FixQualityMeta {
  label: string;
  /** Tailwind class for solid bg (markers). */
  bg: string;
  /** Tailwind class for text on light bg (badges). */
  text: string;
  /** Hex color used directly by Mapbox markers and inline SVG. */
  hex: string;
}

const TABLE: Record<number, FixQualityMeta> = {
  0: { label: "Invalid",    bg: "bg-zinc-400",   text: "text-zinc-700",  hex: "#9ca3af" },
  1: { label: "Single",     bg: "bg-red-500",    text: "text-red-700",   hex: "#ef4444" },
  2: { label: "DGPS",       bg: "bg-orange-500", text: "text-orange-700",hex: "#f97316" },
  3: { label: "PPS",        bg: "bg-violet-500", text: "text-violet-700",hex: "#8b5cf6" },
  4: { label: "Fix",        bg: "bg-emerald-500",text: "text-emerald-700",hex: "#10b981" },
  5: { label: "Float",      bg: "bg-yellow-400", text: "text-yellow-700",hex: "#facc15" },
  6: { label: "Estimated",  bg: "bg-zinc-500",   text: "text-zinc-700",  hex: "#71717a" },
  7: { label: "Manual",     bg: "bg-zinc-500",   text: "text-zinc-700",  hex: "#71717a" },
  8: { label: "Simulation", bg: "bg-sky-400",    text: "text-sky-700",   hex: "#38bdf8" },
};

const UNKNOWN: FixQualityMeta = {
  label: "Unknown",
  bg: "bg-zinc-400",
  text: "text-zinc-700",
  hex: "#9ca3af",
};

export function fixQualityMeta(q: number): FixQualityMeta {
  return TABLE[q] ?? UNKNOWN;
}
